import { useEffect, useRef } from "react";
import { getSDK, trackEvent } from "@/lib/analytics";

function removeQueryParams() {
  const url = new URL(window.location.href);
  if (url.search) {
    const newUrl = url.pathname + url.hash;
    window.history.pushState({}, document.title, newUrl);
  }
}

export function AnalyticsInitializer() {
  const initialized = useRef(false);
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const sendTrackingEvent = async () => {
      try {
        await getSDK(); // Initialize SDK on load
      } catch {
        return;
      }
      const urlParams = new URLSearchParams(window.location.search);
      const payload: { eventName: string; metadata: Record<string, any> | null } = {
        eventName: "",
        metadata: null,
      };
      const tablesessionId = urlParams.get("tid") || urlParams.get("ticket");
      const source = urlParams.get("s") || urlParams.get("source");
      const brandId = window.location.hostname.toLowerCase().includes("satumeja") ? "SM" : "DA";

      if (tablesessionId) {
        payload.eventName = "page_order";
        payload.metadata = {
          tableSessionId: tablesessionId,
          brandId,
        };
      } else if (source) {
        payload.eventName = "page_view";
        payload.metadata = {
          source: source,
          brandId,
        };
      }

      if (payload.eventName && payload.metadata) {
        await trackEvent(payload.eventName, payload.metadata);
        removeQueryParams();
      }
    };

    sendTrackingEvent();
  }, []);

  return null;
}